import type { TimeSlot } from "@/lib/actions/actions";
import {
  displayTimeInPracticeTimeZone,
  displayTimeInUserTimeZone,
  getTimezoneAbbreviation,
} from "@frontend/lib/timezone/timezone-utils";
import { Button } from "@frontend/shared/components/ui/button";
import { Loader2 } from "lucide-react";
import { useCallback, useState } from "react";
import { useBooking } from "../context/BookingContext";

interface TimeSlotButtonProps {
  timeSlot: TimeSlot;
  onSelect: () => Promise<void>;
  timeZone: string;
}

export function TimeSlotButton({
  timeSlot,
  onSelect,
  timeZone,
}: TimeSlotButtonProps) {
  const { isVirtualVisit } = useBooking();
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = useCallback(() => {
    if (isClicked) return;
    setIsClicked(true);
    onSelect();
  }, [isClicked, onSelect]);
  return (
    <Button
      onClick={handleClick}
      disabled={isClicked}
      variant="outline"
      className="w-full text-xs py-2 px-4 flex gap-1 min-w-24"
      data-cy="time-slot-button"
      data-visit-id={timeSlot.ehrAppointmentId}
      data-slot-datetime={timeSlot.dateTime}
    >
      {isClicked ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
      <div>
        {isVirtualVisit
          ? displayTimeInUserTimeZone(timeSlot.dateTime)
          : displayTimeInPracticeTimeZone(
              timeSlot.dateTime,
              timeSlot.timezone ?? timeZone,
            )}
      </div>
      <div className="text-xs text-gray-500">
        {!isVirtualVisit &&
          getTimezoneAbbreviation(timeSlot.timezone ?? timeZone)}
      </div>
    </Button>
  );
}
